// extracted by mini-css-extract-plugin
export default {"wrapper":"ZirvuFileManagerDialogInputText_wrapper__HGjRn"};